import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { LoginMasterComponent } from './pages/login-master/login-master.component';
import { ResetPageComponent } from './pages/reset-page/reset-page.component';
import { SignUpPageComponent } from './pages/sign-up-page/sign-up-page.component';
import { LoginArt } from './models/login-art.enum';

const routes: Routes = [
  {
    path: 'login',
    component: LoginMasterComponent,
    children: [
      {
        path: '',
        component: LoginPageComponent,
        data: {
          loginArt: LoginArt.login
        }
      },
      {
        path: 'reset',
        component: ResetPageComponent,
        data: {
          loginArt: LoginArt.login
        }
      },
      {
        path: 'create',
        component: SignUpPageComponent,
        data: {
          loginArt: LoginArt.signUp
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
